module.exports = __webpack_public_path__ + "img/schema 3 - NL.d3c690cf.svg";